<div class="flex flex-row flex-nowrap justify-between px-4 py-2.5">
  <ra-title></ra-title>
  <button
    (click)="closeSelf.emit()"
    class="p-2 border-0 bg-gray-100 rounded-lg justify-center items-center gap-2 inline-flex"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 5.25L5.25 18.75"
        stroke="#050A24"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.75 18.75L5.25 5.25"
        stroke="#050A24"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</div>
<div
  class="relative flex flex-col px-4 h-full overflow-y-auto overflow-x-hidden max-h-[calc(100%-60px)]"
>
<!--    <div class="mb-4 inline-flex flex-nowrap gap-1.5">-->
<!--      <a-->
<!--        href="https://rentag.ru/auth"-->

<!--        pButton-->
<!--        class="flex-1 p-button-tetriary p-button-s"-->
<!--      >-->
<!--        Войти в аккаунт-->
<!--      </a>-->
<!--    </div>-->
<!--  <div class="mb-10 grid">-->
<!--    <button-->
<!--      pButton-->
<!--      (click)="openModal('create')"-->
<!--      class="p-button-secondary p-button-s font-bold bg-gray-100 rounded-lg border-none justify-center items-center inline-flex"-->
<!--    >-->
<!--      Разместить объявление-->
<!--      <svg-->
<!--        class="ml-2"-->
<!--        width="8"-->
<!--        height="4"-->
<!--        viewBox="0 0 8 4"-->
<!--        fill="none"-->
<!--        xmlns="http://www.w3.org/2000/svg"-->
<!--      >-->
<!--        <path-->
<!--          d="M7.73807 0.204157C7.71223 0.143494 7.66877 0.0917348 7.61317 0.055404C7.55758 0.0190731 7.49232 -0.000204223 7.42564 1.63161e-06H0.670413C0.603731 -0.000204223 0.538479 0.0190731 0.48288 0.055404C0.427281 0.0917348 0.383823 0.143494 0.357984 0.204157C0.33365 0.265724 0.327477 0.332832 0.340178 0.397717C0.35288 0.462602 0.383938 0.522612 0.429758 0.570804L3.80737 3.90396C3.87193 3.96556 3.95822 4 4.04803 4C4.13783 4 4.22412 3.96556 4.28868 3.90396L7.6663 0.570804C7.71212 0.522612 7.74317 0.462602 7.75588 0.397717C7.76858 0.332832 7.7624 0.265724 7.73807 0.204157Z"-->
<!--          fill="#720AA4"-->
<!--        />-->
<!--      </svg>-->
<!--    </button>-->
<!--  </div>-->

  <ul class="flex flex-col flex-1">
    <li class="flex flex-col">
      <button
        (click)="showAdditional.estate = !showAdditional.estate"
        class="p-0 m-0 w-full border-none py-3 inline-flex justify-between items-center"
      >
        <span class="flex flex-nowrap space-x-[6px]">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_5987_22722)">
              <path
                d="M15 8.25H19.5C19.6989 8.25 19.8897 8.32902 20.0303 8.46967C20.171 8.61032 20.25 8.80109 20.25 9V20.25"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.5 20.25H22.5"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.25 10.5V11.625"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.5 10.5V11.625"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.5 15.375V16.5"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.25 15.375V16.5"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.75 20.2499V7.55147C3.74993 7.4088 3.79056 7.26907 3.86711 7.14868C3.94366 7.02829 4.05296 6.93223 4.18219 6.87178L13.9322 2.32115C14.0464 2.2677 14.1723 2.24393 14.2982 2.25204C14.4241 2.26015 14.5459 2.29987 14.6523 2.36754C14.7588 2.4352 14.8465 2.52862 14.9072 2.63916C14.968 2.74969 14.9999 2.87377 15 2.9999V20.2499"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_5987_22722">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="text-slate-950 text-base font-normal leading-snug"
            >Ком. недвижимость</span
          >
        </span>
        <span class="flex items-center justify-center">
          <ng-container
            *ngIf="
              showAdditional.estate;
              then OpenedSubMenu;
              else ClosedSubMenu
            "
          ></ng-container>
        </span>
      </button>
      <ng-container *ngIf="showAdditional.estate">
        <div
          class="bg-white rounded-lg flex-col justify-start items-start inline-flex"
        >
          <a

            href="https://rentag.ru/kommercheskaya-nedvizhimost"
            target="_blank"
            rel="noreferrer"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Главная страница
            </div>
          </a>
          <a

            href="https://rentag.ru/kommercheskaya-nedvizhimost?modal=rent"
            target="_blank"
            rel="noreferrer"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Сдать недвижимость
            </div>
          </a>
          <a

            href="https://rentag.ru/kommercheskaya-nedvizhimost?modal=rentout"
            target="_blank"
            rel="noreferrer"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Арендовать недвижимость
            </div>
          </a>
          <a
            href="https://rentag.ru/kommercheskaya-nedvizhimost/arendatoram"
            target="_blank"
            rel="noreferrer"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Арендаторам
            </div>
          </a>
          <a
            href="https://rentag.ru/kommercheskaya-nedvizhimost/arendodatelyam"
            target="_blank"
            rel="noreferrer"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Арендодателям
            </div>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://rentag.ru/kommercheskaya-nedvizhimost/agentstvam"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Агентствам
            </div>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://rentag.ru/kommercheskaya-nedvizhimost/tender"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Тендер
            </div>
          </a>
          <a
            target="_blank"
            rel="nofollow"
            href="https://rentag.ru/tarify"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Тарифы
            </div>
          </a>
        </div>
      </ng-container>
    </li>
    <li class="flex flex-col">
      <button
        (click)="showAdditional.transport = !showAdditional.transport"
        class="p-0 m-0 w-full border-none py-3 inline-flex justify-between items-center"
      >
        <span class="flex flex-nowrap space-x-[6px]">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_5987_22735)">
              <path
                d="M1.5 11.25H22.5"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M20.25 20.25H18C17.8011 20.25 17.6103 20.171 17.4697 20.0303C17.329 19.8897 17.25 19.6989 17.25 19.5V17.25H6.75V19.5C6.75 19.6989 6.67098 19.8897 6.53033 20.0303C6.38968 20.171 6.19891 20.25 6 20.25H3.75C3.55109 20.25 3.36032 20.171 3.21967 20.0303C3.07902 19.8897 3 19.6989 3 19.5V11.25L5.80219 4.94531C5.86112 4.81276 5.95722 4.70015 6.07886 4.62111C6.20049 4.54207 6.34244 4.5 6.4875 4.5H17.5125C17.6576 4.5 17.7995 4.54207 17.9211 4.62111C18.0428 4.70015 18.1389 4.81276 18.1978 4.94531L21 11.25V19.5C21 19.6989 20.921 19.8897 20.7803 20.0303C20.6397 20.171 20.4489 20.25 20.25 20.25Z"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_5987_22735">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <span class="text-slate-950 text-base font-normal leading-snug"
            >Транспорт</span
          >
        </span>

        <span class="flex items-center justify-center">
          <ng-container
            *ngIf="
              showAdditional.transport;
              then OpenedSubMenu;
              else ClosedSubMenu
            "
          ></ng-container>
        </span>
      </button>
      <ng-container *ngIf="showAdditional.transport">
        <div
          class="bg-white rounded-lg flex-col justify-start items-start inline-flex"
        >
          <a
            target="_blank"
            rel="noreferrer"
            href="https://rentag.ru/arenda-avto"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Главная страница
            </div>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://rentag.ru/lk/transport/rent/create"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Сдать транспорт
            </div>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://rentag.ru/arenda-avto"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Арендовать транспорт
            </div>
          </a>
        </div>
      </ng-container>
    </li>
    <li class="flex flex-col">
      <button
        (click)="showAdditional.commercial = !showAdditional.commercial"
        class="p-0 m-0 w-full border-none py-3 inline-flex justify-between items-center"
      >
        <span class="flex flex-nowrap space-x-[6px]">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_5987_22742)">
              <path
                d="M4.5 9.375H19.5"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19.5 16.875H4.5V6C4.5 5.40326 4.73705 4.83097 5.15901 4.40901C5.58097 3.98705 6.15326 3.75 6.75 3.75H17.25C17.8467 3.75 18.419 3.98705 18.841 4.40901C19.2629 4.83097 19.5 5.40326 19.5 6V16.875Z"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19.5 16.875V19.5C19.5 19.6989 19.421 19.8897 19.2803 20.0303C19.1397 20.171 18.9489 20.25 18.75 20.25H16.125C15.9261 20.25 15.7353 20.171 15.5947 20.0303C15.454 19.8897 15.375 19.6989 15.375 19.5V16.875"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.625 16.875V19.5C8.625 19.6989 8.54598 19.8897 8.40533 20.0303C8.26468 20.171 8.07391 20.25 7.875 20.25H5.25C5.05109 20.25 4.86032 20.171 4.71967 20.0303C4.57902 19.8897 4.5 19.6989 4.5 19.5V16.875"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.625 14.625C9.45343 14.625 10.125 13.9534 10.125 13.125C10.125 12.2966 9.45343 11.625 8.625 11.625C7.79657 11.625 7.125 12.2966 7.125 13.125C7.125 13.9534 7.79657 14.625 8.625 14.625Z"
                fill="#050A24"
              />
              <path
                d="M15.375 14.625C16.2034 14.625 16.875 13.9534 16.875 13.125C16.875 12.2966 16.2034 11.625 15.375 11.625C14.5466 11.625 13.875 12.2966 13.875 13.125C13.875 13.9534 14.5466 14.625 15.375 14.625Z"
                fill="#050A24"
              />
              <path
                d="M22.875 7.5V9.75"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.125 7.5V9.75"
                stroke="#050A24"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_5987_22742">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <span class="text-slate-950 text-base font-normal leading-snug"
            >Спецтехника</span
          >
        </span>

        <span class="flex items-center justify-center">
          <ng-container
            *ngIf="
              showAdditional.commercial;
              then OpenedSubMenu;
              else ClosedSubMenu
            "
          ></ng-container>
        </span>
      </button>
      <ng-container *ngIf="showAdditional.commercial">
        <div
          class="bg-white rounded-lg flex-col justify-start items-start inline-flex"
        >
          <a
            target="_blank"
            rel="noreferrer"
            href="https://rentag.ru/arenda-spectehniki"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Главная страница
            </div>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://rentag.ru/lk/com-transport/rent/create"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Сдать спецтехнику
            </div>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://rentag.ru/arenda-spectehniki"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Арендовать спецтехнику
            </div>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://rentag.ru/arenda-spectehniki/zayavki"
            class="self-stretch px-3.5 py-2 bg-white justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Заявки арендаторов
            </div>
          </a>
        </div>
      </ng-container>
    </li>
    <div class="h-[1px] bg-[#EBECF0] my-2 shrink-0"></div>


    <li class="flex">
      <a
        target="_blank"
        class="text-slate-950 text-base font-normal leading-snug py-3"
        href="https://rentag.ru/o-proekte"
        rel="nofollow"
        >О сервисе</a
      >
    </li>
    <li class="flex">
      <a
        target="_blank"
        class="text-slate-950 text-base font-normal leading-snug py-3"
        href="https://rentag.ru/tarify"
        rel="nofollow"
        >Тарифы</a
      >
    </li>
    <li class="flex">
      <a
        target="_blank"
        class="text-slate-950 text-base font-normal leading-snug py-3"
        href="https://rentag.ru/investoram"
        rel="nofollow"
        >Инвесторам</a
      >
    </li>
    <li class="flex">
      <a
        target="_blank"
        class="text-slate-950 text-base font-normal leading-snug py-3"
        href="https://rentag.ru/kontakty"
        rel="nofollow"
        >Контакты</a
      >
    </li>

    <li class="flex flex-col">
      <button
        (click)="showAdditional.etc = !showAdditional.etc"
        class="p-0 m-0 w-full border-none py-3 inline-flex justify-start space-x-[6px] items-center"
      >
        <span class="text-slate-950 text-base font-normal leading-snug"
          >Еще</span
        >

        <span class="flex items-center justify-center">
          <ng-container
            *ngIf="showAdditional.etc; then OpenedSubMenu; else ClosedSubMenu"
          ></ng-container>
        </span>
      </button>
      <ng-container *ngIf="showAdditional.etc">
        <div
          class="bg-white rounded-lg flex-col justify-start items-start inline-flex"
        >
          <a
            target="_blank"
            href="https://rentag.ru/karera"
            rel="nofollow"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Карьера
            </div>
          </a>
          <a
            target="_blank"
            href="https://rentag.ru/faq"
            rel="nofollow"
            class="self-stretch px-3.5 py-2 bg-white border-b border-gray-200 border-solid justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              База знаний
            </div>
          </a>
          <a
            target="_blank"
            href="https://rentag.ru/documents"
            rel="nofollow"
            class="self-stretch px-3.5 py-2 bg-white justify-start items-center gap-2 inline-flex"
          >
            <div
              class="text-center text-slate-950 text-sm font-normal leading-tight"
            >
              Юридические документы
            </div>
          </a>
        </div>
      </ng-container>
    </li>
  </ul>

<!--  <div-->
<!--    class="w-screen flex flex-col border-t border-gray-200 border-solid bg-white px-4 -mx-4"-->
<!--  >-->
<!--    <button-->
<!--      (click)="openFeedbackModal(9)"-->
<!--      class="flex cursor-pointer w-full py-3 border-none p-0 m-0 text-slate-950 text-base leading-snug text-left"-->
<!--    >-->
<!--      <span class="mr-[6px] flex justify-center items-center">-->
<!--        <svg-->
<!--          width="24"-->
<!--          height="24"-->
<!--          viewBox="0 0 24 24"-->
<!--          fill="none"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--        >-->
<!--          <g clip-path="url(#clip0_5987_22771)">-->
<!--            <path-->
<!--              d="M12.6878 2.70951L14.8656 7.89951C14.9183 8.02547 15.0044 8.13464 15.1146 8.21526C15.2248 8.29589 15.3549 8.3449 15.4909 8.35701L21.0653 8.83889C21.2132 8.85077 21.3543 8.90627 21.4706 8.99835C21.587 9.09043 21.6734 9.21495 21.719 9.35616C21.7645 9.49738 21.7672 9.64893 21.7266 9.79166C21.686 9.93438 21.604 10.0619 21.4909 10.1579L17.2619 13.847C17.1591 13.9373 17.0827 14.0538 17.0407 14.184C16.9988 14.3142 16.9929 14.4534 17.0237 14.5867L18.2912 20.0748C18.3247 20.2182 18.3153 20.3682 18.2641 20.5062C18.213 20.6442 18.1223 20.7641 18.0035 20.851C17.8846 20.9379 17.7428 20.9878 17.5958 20.9947C17.4488 21.0015 17.303 20.965 17.1766 20.8895L12.3859 17.9833C12.2695 17.9125 12.1359 17.875 11.9997 17.875C11.8634 17.875 11.7298 17.9125 11.6134 17.9833L6.8228 20.8895C6.6964 20.965 6.55059 21.0015 6.40355 20.9947C6.25651 20.9878 6.11473 20.9379 5.99589 20.851C5.87704 20.7641 5.78639 20.6442 5.73522 20.5062C5.68404 20.3682 5.67462 20.2182 5.70811 20.0748L6.97561 14.5867C7.00642 14.4534 7.00055 14.3142 6.95863 14.184C6.9167 14.0538 6.84028 13.9373 6.73749 13.847L2.50843 10.1579C2.39536 10.0619 2.31335 9.93438 2.27275 9.79166C2.23216 9.64893 2.23481 9.49738 2.28038 9.35616C2.32594 9.21495 2.41237 9.09043 2.52873 8.99835C2.64509 8.90627 2.78615 8.85077 2.93405 8.83889L8.50843 8.35701C8.64443 8.3449 8.77454 8.29589 8.88474 8.21526C8.99493 8.13464 9.08103 8.02547 9.13374 7.89951L11.3116 2.70951C11.3697 2.57533 11.4658 2.46108 11.5881 2.38083C11.7104 2.30057 11.8534 2.25781 11.9997 2.25781C12.1459 2.25781 12.289 2.30057 12.4112 2.38083C12.5335 2.46108 12.6296 2.57533 12.6878 2.70951Z"-->
<!--              stroke="#050A24"-->
<!--              stroke-width="2"-->
<!--              stroke-linecap="round"-->
<!--              stroke-linejoin="round"-->
<!--            />-->
<!--          </g>-->
<!--          <defs>-->
<!--            <clipPath id="clip0_5987_22771">-->
<!--              <rect width="24" height="24" fill="white" />-->
<!--            </clipPath>-->
<!--          </defs>-->
<!--        </svg>-->
<!--      </span>-->
<!--      Предложить идею-->
<!--    </button>-->
<!--    <button-->
<!--      (click)="openModal('support')"-->
<!--      class="flex cursor-pointer w-full py-3 border-none p-0 m-0 text-slate-950 text-base leading-snug text-left"-->
<!--    >-->
<!--      <span class="mr-[6px] flex justify-center items-center">-->
<!--        <svg-->
<!--          width="24"-->
<!--          height="24"-->
<!--          viewBox="0 0 24 24"-->
<!--          fill="none"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--        >-->
<!--          <g clip-path="url(#clip0_5987_22775)">-->
<!--            <path-->
<!--              d="M21 18.75V19.5C21 20.2956 20.6839 21.0587 20.1213 21.6213C19.5587 22.1839 18.7956 22.5 18 22.5H12.75"-->
<!--              stroke="#050A24"-->
<!--              stroke-width="2"-->
<!--              stroke-linecap="round"-->
<!--              stroke-linejoin="round"-->
<!--            />-->
<!--            <path-->
<!--              d="M21 12H18C17.6022 12 17.2206 12.158 16.9393 12.4393C16.658 12.7206 16.5 13.1022 16.5 13.5V17.25C16.5 17.6478 16.658 18.0294 16.9393 18.3107C17.2206 18.592 17.6022 18.75 18 18.75H21V12ZM21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12M3 12V17.25C3 17.6478 3.15804 18.0294 3.43934 18.3107C3.72064 18.592 4.10218 18.75 4.5 18.75H6C6.39782 18.75 6.77936 18.592 7.06066 18.3107C7.34196 18.0294 7.5 17.6478 7.5 17.25V13.5C7.5 13.1022 7.34196 12.7206 7.06066 12.4393C6.77936 12.158 6.39782 12 6 12H3Z"-->
<!--              stroke="#050A24"-->
<!--              stroke-width="2"-->
<!--              stroke-linecap="round"-->
<!--              stroke-linejoin="round"-->
<!--            />-->
<!--          </g>-->
<!--          <defs>-->
<!--            <clipPath id="clip0_5987_22775">-->
<!--              <rect width="24" height="24" fill="white" />-->
<!--            </clipPath>-->
<!--          </defs>-->
<!--        </svg>-->
<!--      </span>-->
<!--      Служба поддержки-->
<!--    </button>-->
<!--    <div class="inline-flex justify-between items-center py-3">-->
<!--      <div class="flex justify-center items-center">-->
<!--        <span class="mr-[6px] flex justify-center items-center">-->
<!--          <svg-->
<!--            width="24"-->
<!--            height="24"-->
<!--            viewBox="0 0 24 24"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <g clip-path="url(#clip0_5987_22782)">-->
<!--              <path-->
<!--                d="M12 1.5C9.81273 1.50248 7.71575 2.37247 6.16911 3.91911C4.62247 5.46575 3.75248 7.56273 3.75 9.75C3.75 16.8094 11.25 22.1409 11.5697 22.3641C11.6958 22.4524 11.846 22.4998 12 22.4998C12.154 22.4998 12.3042 22.4524 12.4303 22.3641C12.75 22.1409 20.25 16.8094 20.25 9.75C20.2475 7.56273 19.3775 5.46575 17.8309 3.91911C16.2843 2.37247 14.1873 1.50248 12 1.5ZM12 6.75C12.5933 6.75 13.1734 6.92595 13.6667 7.25559C14.1601 7.58524 14.5446 8.05377 14.7716 8.60195C14.9987 9.15013 15.0581 9.75333 14.9424 10.3353C14.8266 10.9172 14.5409 11.4518 14.1213 11.8713C13.7018 12.2909 13.1672 12.5766 12.5853 12.6924C12.0033 12.8081 11.4001 12.7487 10.8519 12.5216C10.3038 12.2946 9.83524 11.9101 9.50559 11.4167C9.17595 10.9234 9 10.3433 9 9.75C9 8.95435 9.31607 8.19129 9.87868 7.62868C10.4413 7.06607 11.2044 6.75 12 6.75Z"-->
<!--                fill="#050A24"-->
<!--              />-->
<!--            </g>-->
<!--            <defs>-->
<!--              <clipPath id="clip0_5987_22782">-->
<!--                <rect width="24" height="24" fill="white" />-->
<!--              </clipPath>-->
<!--            </defs>-->
<!--          </svg>-->
<!--        </span>-->
<!--        <span>-->
<!--          @if (_regionSettings.regionalityState$ | async; as state) {-->
<!--            {{ state.city.name }}-->
<!--          }-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</div>

<ng-template #OpenedSubMenu>
  <svg
    width="8"
    height="4"
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.7377 3.79584C7.71186 3.85651 7.66841 3.90827 7.61281 3.9446C7.55721 3.98093 7.49196 4.0002 7.42527 4H0.670047C0.603365 4.0002 0.538112 3.98093 0.482513 3.9446C0.426915 3.90827 0.383457 3.85651 0.357618 3.79584C0.333284 3.73428 0.32711 3.66717 0.339812 3.60228C0.352514 3.5374 0.383572 3.47739 0.429392 3.4292L3.80701 0.0960402C3.87157 0.0344367 3.95786 0 4.04766 0C4.13747 0 4.22376 0.0344367 4.28832 0.0960402L7.66593 3.4292C7.71175 3.47739 7.74281 3.5374 7.75551 3.60228C7.76821 3.66717 7.76204 3.73428 7.7377 3.79584Z"
      fill="#050A24"
    />
  </svg>
</ng-template>

<ng-template #ClosedSubMenu>
  <svg
    width="8"
    height="4"
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.7377 0.204157C7.71186 0.143494 7.66841 0.0917348 7.61281 0.055404C7.55721 0.0190731 7.49196 -0.000204223 7.42527 1.63161e-06H0.670047C0.603365 -0.000204223 0.538112 0.0190731 0.482513 0.055404C0.426915 0.0917348 0.383457 0.143494 0.357618 0.204157C0.333284 0.265724 0.32711 0.332832 0.339812 0.397717C0.352514 0.462602 0.383572 0.522612 0.429392 0.570804L3.80701 3.90396C3.87157 3.96556 3.95786 4 4.04766 4C4.13747 4 4.22376 3.96556 4.28832 3.90396L7.66593 0.570804C7.71175 0.522612 7.74281 0.462602 7.75551 0.397717C7.76821 0.332832 7.76204 0.265724 7.7377 0.204157Z"
      fill="#050A24"
    />
  </svg>
</ng-template>

<!--<ra-modal-container-swipe-->
<!--  [visible]="showModal.create"-->
<!--  [close]="close.bind(this)"-->
<!--&gt;-->
<!--  <div class="flex-col flex">-->
<!--    <a-->
<!--      href="https://rentag.ru/kommercheskaya-nedvizhimost"-->
<!--      [queryParams]="{ modal: 'select' }"-->
<!--      class="px-4 py-4 cursor-pointer"-->
<!--      -->
<!--    >-->
<!--      Коммерческая недвижимость</a-->
<!--    >-->
<!--    <a-->
<!--      href="https://rentag.ru/lk/transport/rent/create"-->
<!--      class="border-t border-solid border-gray-300 px-4 py-4 cursor-pointer"-->
<!--      -->
<!--    >-->
<!--      Транспорт-->
<!--    </a>-->
<!--    <a-->
<!--      href="https://rentag.ru/lk/com-transport/rent/create"-->
<!--      class="border-t border-solid border-gray-300 px-4 py-4 cursor-pointer"-->
<!--      -->
<!--    >-->
<!--      Спецтехника-->
<!--    </a>-->
<!--  </div>-->
<!--</ra-modal-container-swipe>-->

<!--<ra-modal-container-swipe-->
<!--  [visible]="showModal.favorites"-->
<!--  [close]="close.bind(this)"-->
<!--&gt;-->
<!--  <div class="flex-col flex">-->
<!--    <a-->
<!--      href="https://rentag.ru/lk/transport/rent-out/favorites"-->
<!--      class="px-4 py-4 cursor-pointer"-->
<!--      -->
<!--    >-->
<!--      Транспорт-->
<!--    </a>-->
<!--    <a-->
<!--      href="https://rentag.ru/lk/com-transport/rent-out/favorites"-->
<!--      class="border-t border-solid border-gray-300 px-4 py-4 cursor-pointer"-->
<!--      -->
<!--    >-->
<!--      Спецтехника-->
<!--    </a>-->
<!--  </div>-->
<!--</ra-modal-container-swipe>-->

<!--<ra-modal-container-swipe-->
<!--  [visible]="showModal.offers"-->
<!--  [close]="close.bind(this)"-->
<!--&gt;-->
<!--  <div class="flex-col flex">-->
<!--    <a-->
<!--      href="https://rentag.ru/lk/transport/rent/my-offers"-->
<!--      class="px-4 py-4 cursor-pointer"-->
<!--      -->
<!--    >-->
<!--      Транспорт-->
<!--    </a>-->
<!--    <a-->
<!--      href="https://rentag.ru/lk/com-transport/rent/my-offers"-->
<!--      class="border-t border-solid border-gray-300 px-4 py-4 cursor-pointer"-->
<!--      -->
<!--    >-->
<!--      Спецтехника-->
<!--    </a>-->
<!--  </div>-->
<!--</ra-modal-container-swipe>-->

<!--<ra-modal-container-swipe-->
<!--  [visible]="showModal.support"-->
<!--  [close]="close.bind(this)"-->
<!--  title="Остались вопросы или нужна помощь?"-->
<!--&gt;-->
<!--  <div class="flex-col justify-start items-start flex w-full mt-4">-->
<!--    <div class="flex-col justify-start items-start gap-1 flex mb-4">-->
<!--      <a-->
<!--        href="tel:88005508586"-->
<!--        class="text-slate-950 text-base font-bold leading-snug"-->
<!--        >8 800 550-85-86</a-->
<!--      >-->
<!--      <div class="text-slate-600 text-sm font-normal leading-tight">-->
<!--        Отвечаем с 10 до 19 по МСК-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="flex-col justify-start items-start gap-1 flex mb-4">-->
<!--      <a-->
<!--        href="mailto:sales@rentag.ru"-->
<!--        class="text-slate-950 text-base font-bold leading-snug"-->
<!--        >sales&#64;rentag.ru</a-->
<!--      >-->
<!--      <div class="text-slate-600 text-sm font-normal leading-tight">-->
<!--        Напишите сейчас — ответим в рабочее время-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="flex-col justify-center items-start gap-2 flex w-full mb-4">-->
<!--      <p class="text-left">-->
<!--        <span class="mr-1 text-slate-600 text-sm font-normal leading-tight"-->
<!--          >или</span-->
<!--        >-->
<!--        <a-->
<!--          [routerLink]="'/faq'"-->
<!--          rel="nofollow"-->
<!--          -->
<!--          class="underline text-slate-600 text-sm font-normal leading-tight"-->
<!--          >воспользуйтесь нашей вспомогательной базой</a-->
<!--        >-->
<!--      </p>-->
<!--    </div>-->
<!--    <button-->
<!--      (click)="openFeedbackModal(6)"-->
<!--      class="inline-flex items-center justify-center border-none"-->
<!--    >-->
<!--      <svg-->
<!--        class="mr-2"-->
<!--        width="18"-->
<!--        height="18"-->
<!--        viewBox="0 0 24 24"-->
<!--        fill="none"-->
<!--        xmlns="http://www.w3.org/2000/svg"-->
<!--      >-->
<!--        <g clip-path="url(#clip0_4047_1217)">-->
<!--          <path-->
<!--            d="M15.4116 13.6257C15.5154 13.5566 15.6349 13.5145 15.7591 13.5032C15.8834 13.4919 16.0085 13.5118 16.1231 13.561L20.5444 15.542C20.6934 15.6057 20.8177 15.7159 20.8989 15.8562C20.98 15.9964 21.0135 16.1592 20.9944 16.3201C20.8487 17.4086 20.3127 18.4071 19.486 19.13C18.6593 19.8529 17.5982 20.2509 16.5 20.2501C13.1185 20.2501 9.87548 18.9068 7.48439 16.5157C5.0933 14.1246 3.75 10.8816 3.75 7.5001C3.74916 6.40192 4.1472 5.3408 4.87009 4.5141C5.59298 3.6874 6.59152 3.15138 7.68 3.00573C7.84091 2.98661 8.00368 3.02012 8.14395 3.10124C8.28422 3.18236 8.39444 3.30673 8.45813 3.45573L10.4391 7.88073C10.4877 7.99438 10.5076 8.1183 10.4968 8.24146C10.486 8.36463 10.4449 8.48321 10.3772 8.58666L8.37375 10.9689C8.30269 11.0761 8.26066 11.1999 8.25179 11.3283C8.24291 11.4566 8.26749 11.585 8.32313 11.701C9.09844 13.2882 10.7391 14.9092 12.3309 15.677C12.4475 15.7324 12.5766 15.7564 12.7053 15.7467C12.834 15.737 12.958 15.6939 13.065 15.6217L15.4116 13.6257Z"-->
<!--            stroke="#720AA4"-->
<!--            stroke-width="1.5"-->
<!--            stroke-linecap="round"-->
<!--            stroke-linejoin="round"-->
<!--          />-->
<!--        </g>-->
<!--      </svg>-->
<!--      <div class="text-purple-800 text-base font-normal leading-[22.4px]">-->
<!--        Заказать обратный звонок-->
<!--      </div>-->
<!--    </button>-->
<!--  </div>-->
<!--</ra-modal-container-swipe>-->
